<script lang="ts" setup>
import { MainMenu } from './useMainMenu'
withDefaults(
  defineProps<{
    menu: MainMenu
    activeId: string | null
  }>(),
  {
    activeId: null,
  },
)
</script>
<template>
  <ul class="sub-menus cul">
    <li v-for="item in menu" v-show="item.id === activeId" :key="item.id">
      <SubMenuMobile :item="item" />
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.box {
  background-color: var(--c-white);
  min-height: 100%;
  width: 100%;
}

.sub-menus {
  background-color: var(--c-white);
  min-height: 100%;
  width: 100%;
  z-index: 1;

  li {
    height: 100%;
  }
}
</style>
